import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Table } from 'primeng/table';
import { UserWalletService } from 'src/app/services/userWallet.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { LazyLoadEvent } from 'primeng/api';
import { saveAs } from 'file-saver/src/FileSaver';
import * as moment from "moment";
import { environment } from 'src/environments/environment';
import * as JSZip from 'jszip';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-usercommission',
  templateUrl: './usercommission.component.html',
  styleUrls: ['./usercommission.component.scss'],
  providers: [MessageService, ConfirmationService, TitleCasePipe]
})

export class UserCommissionComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  yourOptions: any[] = [];
  selectedYear: string;
  public walletlist: any = [];
  public downloadwalletlist: any = [];
  public loading: boolean;
  public totalRecords = 0;
  errorMessage: string;
  public loggedInUser;
  paginationOption;
  yearRange;
  minYear = environment.minYear;
  startDate: any;
  searchby;
  searchBy: any[];
  username: string;
  totalCoins;
  totalDeductedCoin;
  totalAvailableCoins;
  totalCash;
  totalDeductedCash;
  totalAvailableCash;
  description: any;
  endDate: Date;
  downloadFlg: boolean;
  private lastTableLazyLoadEvent: LazyLoadEvent;
  public userId;
  amount=15000;
  public loggedInUserId;
  public loggedInUserData;
  @ViewChild("dt", { static: false }) public dt: Table;

  constructor(
    private tokenStorageService: TokenStorageService,
    private userWalletService: UserWalletService,
    private router: Router,
    private http: HttpClient,
    private messageService: MessageService, private confirmationService: ConfirmationService, private activeroute: ActivatedRoute
  ) {
   }

  ngOnInit() {
    this.updateYearRange();
    this.paginationOption = environment.pagination;
    this.loggedInUserData = this.tokenStorageService.getUser();
    this.loggedInUserId = this.loggedInUserData.userdata['id'];
    this.userId = this.activeroute.snapshot.params.id;
    this.description = [
      { label: "Tournament Registration Fees", value: "Tournament Registration Fees" },
      { label: "Player registered for Tournament", value: "Player registered for Tournament" },
      { label: "Find a Partner Fees", value: "Find a Partner Fees" },
      { label: "Cash Credited On schdeule Registration", value: "Cash Credited On schdeule Registration" },

    ];
    this.downloadFlg = false;
    // this.searchby= this.yearOptions[0]; 
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.amount = 15000;
    // this.searchby= this.yearOptions[0]; 
    this.dt.filter('', 'id', 'contains');
    this.dt.filter('', 'coins', 'contains');
    this.dt.filter('', 'amount', 'contains');
    this.dt.filter('', 'filterByName', 'contains');
    this.dt.filter('', 'userName', 'contains'),
    this.dt.filter('', 'sum', 'contains'),
    this.dt.filter('', 'created_at', 'contains'),
    this.dt.filter('', 'filterByAmounts', 'contains');
    this.dt.filter('','filterBySum','contains');
    this.dt.filter('','filterByStartDate','contains');
    this.dt.filter('','userEmail','contains');
    this.dt.filter('','userMobile','contains');

    // this.pDropDownId.clear(null);
    // if (this.pDropDownId) {
    //   this.pDropDownId.value = "";
    // }
  }
  addNewWallet() {
    this.router.navigate(['/manage/customer/user/wallet/add/' + this.userId]);
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }
  loadWalletHistory(event: LazyLoadEvent) {    
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false"; //&filterByUserid=" + this.userId;
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = (event.first / event.rows) + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 100;
    }
    // if (this.startDate == undefined) {
    //  // params += "&filterByDate=" + this.searchby.value;
    //   params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
    //   //params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    //   console.log(params);
    // }    
    // if(this.searchby != undefined || this.searchby!=''){      
    //   params += "&filterByStartDate=" + this.searchby.value;
    // } else {
    //   params += "&filterByStartDate=2023-2024";
    // }
    if(this.searchby != undefined && this.searchby!=''){
      params += "&filterByStartDate=" + this.searchby;
    } else {
      params += "&filterByStartDate=2024-2025";
    }
    if (event.filters != undefined && event.filters["id"] != undefined) {
      params += "&filterById=" + event.filters["id"].value;
    }
    if (event.filters != undefined && event.filters["userName"] != undefined) {
      params += "&filterByName=" + event.filters["userName"].value;
    }
    //if (event.filters != undefined && event.filters["amount"] != undefined) {
    if(this.amount != undefined && this.amount > 0){
      params += "&filterByAmounts=" +this.amount;
    }
    // if (event.filters != undefined && event.filters["created_at"] != undefined) {
    //   params += "&filterByStartDate=" + event.filters["created_at"].value;
    // }
    if (event.filters != undefined && event.filters["sum"] != undefined) {
      params += "&filterBySum=" + event.filters["sum"].value;      
      
    }
    if (event.filters != undefined && event.filters["userEmail"] != undefined) {
      params += "&filterByEmail=" + event.filters["userEmail"].value;      
      
    }
    if (event.filters != undefined && event.filters["userMobile"] != undefined) {
      params += "&filterByMobile=" + event.filters["userMobile"].value;      
      
    }

    //console.log( event.filters["sum"].value,' event.filters["sum"].value')
  //   if (this.searchBy !== undefined && event.filters !== undefined && event.filters["created_at"] !== undefined && event.filters["created_at"].value !== undefined && event.filters["sum"] !==undefined && event.filters["sum"].value !==undefined) {
  //     console.log('i am in')
  //     params += "&filterByStartDate=" + event.filters["created_at"].value;
  //     params += "&filterBySum=" + event.filters["sum"].value;
  //  }
    
    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.userWalletService.getUserWalletListCommission(query).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.loading = false;        
        this.walletlist = data.data.items;
        this.totalRecords = data.data.totalCount;

      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  updateYearRange(): void {
    const today = new Date();
    const currentYear = today.getFullYear();
    const nextYear = currentYear + 1;
  
    // Check if today is after March 31st or if today is April 1st
    if (today.getMonth() >= 2 || (today.getMonth() === 3 && today.getDate() >= 1)) {
      this.yourOptions = [
        { label: `${currentYear}-${nextYear}`, value: `${currentYear}-${nextYear}` },
        { label: `${currentYear - 1}-${currentYear}`, value: `${currentYear - 1}-${currentYear}` } // Add the previous financial year
      ];
      this.searchby = `${currentYear}-${nextYear}`; // Select the current year as the starting year
    } else {
      const previousYear = currentYear - 1;
      this.yourOptions = [
        { label: `${previousYear}-${currentYear}`, value: `${previousYear}-${currentYear}` }, // Add the previous financial year
        { label: `${currentYear}-${nextYear}`, value: `${currentYear}-${nextYear}` }
      ];
      this.searchby = `${previousYear}-${currentYear}`; // Select the previous year
    }
  }

  
  exportExcel() {
    this.downloadFlg = true;
    this.loadWalletHistory(this.lastTableLazyLoadEvent);
    var propertiesRemove = ['tournamentplayerdata', 'contestdata', 'userId', 'status', 'created_by', 'createdBy', 'updatedby', 'disable', 'updated_at', 'invoiceData', 'userData'];
    this.downloadwalletlist = this.walletlist;
    this.downloadwalletlist.forEach(function (item) {
      if (item.created_at != '') {
        item['created_at'] = moment(item.created_at).format('DD-MM-YYYY');
      }
      propertiesRemove.forEach(function (prop) {
        delete item[prop];
      });
    });

    const columnMapping = {
      'userName': 'User Name',
      'userMobile': 'User Mobile',
      'userEmail': 'User userEmail',
      'sum': 'Amount',
      'created_at': 'Created At'     
    };

    import("xlsx").then(xlsx => {
      const downloadwalletlistWithHeaders = this.downloadwalletlist.map(item => {
        const newItem = {};
        for (const key in item) {
          if (columnMapping.hasOwnProperty(key)) {
            newItem[columnMapping[key]] = item[key];
          }
        }
        return newItem;
      });

      const worksheet = xlsx.utils.json_to_sheet(downloadwalletlistWithHeaders);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
      this.saveAsExcelFile(excelBuffer, "Wallet History");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

  deleteUserWalletEntry(userWalletEntry) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this entry ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        var disableStatus;
        if (userWalletEntry.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }
        var userWalletEntryData = '{"disable":' + disableStatus + '}';
        this.userWalletService.updateUserWallet(userWalletEntry.id, userWalletEntryData).pipe(takeUntil(this.destroy$)).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'User Wallet Entry Deleted', life: 3000 });
            this.loadWalletHistory(this.lastTableLazyLoadEvent);
          },
          err => {
            this.loadWalletHistory(this.lastTableLazyLoadEvent);
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        //this.getUserDetails(user.id);
      }
    });
  }
  downloadPdf(invoiceFile) {
    window.open(invoiceFile);
  }

  generateAndDownloadZip() {
    const zip = new JSZip();
    this.downloadwalletlist = this.walletlist;
    const pdfObservables = [];

    this.downloadwalletlist.forEach((el) => {
      if (el.invoiceFile) {
        pdfObservables.push(
          this.http.get(el.invoiceFile, { responseType: 'blob' })
        );
      }

    });

    forkJoin(pdfObservables).pipe(takeUntil(this.destroy$)).subscribe((pdfBlobs: any) => {
      pdfBlobs.forEach((pdfBlob, index) => {
        zip.file(`${this.downloadwalletlist[index].id}.pdf`, pdfBlob);
      });
      zip.generateAsync({ type: 'blob' }).then((blob) => {
        saveAs(blob, `${new Date().getTime()}.zip`);
      });
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}